import { useEffect, useRef } from "react";
import { isProductBarcode } from "@/lib/barcode";

// Fiziksel barkod okuyucu (klavye emülasyonu) için global dinleyici.
// Okuyucular karakterleri çok hızlı gönderip Enter ile bitirir. Bir input/textarea/select
// veya contenteditable öğe odaktayken tetiklenmez (o alanı doğrudan doldurur, sayfa kendi işler).
// Yalnızca ürün barkodu görünümlü kodlar iletilir (QR'dan gelen URL/metin yok sayılır).
export function useGlobalScanner(onScan, { minLength = 3, maxGapMs = 110 } = {}) {
  const buf = useRef("");
  const last = useRef(0);
  const cb = useRef(onScan);
  useEffect(() => { cb.current = onScan; }, [onScan]);

  useEffect(() => {
    const isTyping = () => {
      const el = document.activeElement;
      if (!el) return false;
      const tag = (el.tagName || "").toLowerCase();
      return tag === "input" || tag === "textarea" || tag === "select" || el.isContentEditable;
    };
    const onKey = (e) => {
      if (e.ctrlKey || e.metaKey || e.altKey) return;
      const now = Date.now();
      if (now - last.current > maxGapMs) buf.current = "";   // yavaş giriş → insan yazıyor, sıfırla
      last.current = now;
      if (e.key === "Enter") {
        const code = buf.current.trim();
        buf.current = "";
        if (code.length >= minLength && !isTyping() && isProductBarcode(code)) cb.current(code);
        return;
      }
      if (e.key.length === 1) buf.current += e.key;
    };
    document.addEventListener("keydown", onKey, true);
    return () => document.removeEventListener("keydown", onKey, true);
  }, [minLength, maxGapMs]);
}

// Sayfa-seviyesi kayıt: bir sayfa (ör. Hızlı Satış) barkodu kendisi işlemek isterse
// buraya bir handler kaydeder; global dinleyici varsa önce ona verir (kataloğa yönlendirmez).
let _pageHandler = null;
export function setScanPageHandler(fn) {
  _pageHandler = fn;
  return () => { if (_pageHandler === fn) _pageHandler = null; };
}
export function getScanPageHandler() {
  return _pageHandler;
}
